import { FieldGroup, FormLines, StaticField, useTestIds } from "@homebound/beam";
import { Price } from "src/components/Price";
import { ChangeEventType } from "src/generated/graphqlTypes";
import { celisImpactTotals } from "src/routes/projects/change-events/guided/utils";
import { ReviewStep_ChangeEventFragment } from "src/routes/projects/change-events/guided/workflows/sharedSteps/ReviewStep.generated";
import { count } from "src/utils";
import { ReviewImpactedPrice } from "../workflows/components/ReviewImpactedPrice";

type ReviewSummaryStatsProps = { changeEvent: ReviewStep_ChangeEventFragment };

export function ReviewSummaryStats(props: ReviewSummaryStatsProps) {
  const { changeEvent } = props;
  const { lineItems, budgetImpactInCents, totalPriceInCents, impactedCommitments, type, project } = changeEvent;
  const { totalAddedInCents, totalRemovedInCents, changedItems } = celisImpactTotals(lineItems);
  const tid = useTestIds(props, "summaryStats");
  return (
    <FormLines labelStyle="left" width="full" compact>
      <FieldGroup>
        <StaticField
          label="Chargeable"
          value={type.code === ChangeEventType.External ? `To ${project.lotType.clientNoun}` : "No"}
          {...tid.chargeable}
        />
        <StaticField label="Scope Impact" value={count(changedItems, "item")} {...tid.scopeImpact} />
      </FieldGroup>
      <FieldGroup>
        <StaticField label="Total Added" {...tid.totalAdded}>
          <Price valueInCents={totalAddedInCents} />
        </StaticField>
        <StaticField label="Committed Items" value={String(impactedCommitments.length)} {...tid.committedItems} />
      </FieldGroup>
      <FieldGroup>
        <StaticField label="Total Removed" {...tid.totalRemoved}>
          <Price valueInCents={totalRemovedInCents} />
        </StaticField>
        <StaticField label="Budget Impact" {...tid.budgetImpact}>
          <ReviewImpactedPrice valueInCents={budgetImpactInCents} />
        </StaticField>
      </FieldGroup>
      <FieldGroup>
        <StaticField label="Price Impact" {...tid.priceImpact}>
          <ReviewImpactedPrice valueInCents={totalPriceInCents} />
        </StaticField>
        {/* An empty right cell so `Price Impact` lines up with the left column above it. */}
        <div />
      </FieldGroup>
    </FormLines>
  );
}
